import LicenseCount from "./LicenseCount";
export default LicenseCount;